import fetch from 'auth/FetchInterceptor'
import {X_API_KEY} from "../configs/AppConfig";
import {AUTH_TIPE} from "../constants/AuthConstant";

const  pengajuanLemburService = {}

pengajuanLemburService.data = function (token,data='') {
    return fetch({
        url: '/transaksi/pengajuan_lembur/data',
        method: 'post',
        data: data,
        params: {},
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

export default pengajuanLemburService;
